<template lang="pug">
.pa-2
  v-dialog(v-model='isModalExportar'  fullscreen)
    parametros-exportacion(
      v-if="isModalExportar",
      :id="idReporteExportar"
      preview="save"
      @close="closeDialogExportar"
    )
  v-dialog(v-model='isModalEliminar'  max-width='350')
    v-card.pa-4
      strong.font-size-17
        | ¿Realmente deseas eliminar el reporte
        strong.primary--text &nbsp; {{reporteAEliminar.titulo}}?
      v-card-text.mt-4.px-0
        span.font-size-12 Si continuas con este proceso el reporte se eliminará permanentemente y no se podra recuperar
      v-card-actions
        v-spacer
        v-btn.mr-1(color='ligth' small @click='closeDialogEliminar')
          | cancelar
        v-btn(color='primary' small @click='fetchEliminarReporte()')
          | Eliminar
  v-dialog(v-model='isModalGuardarReporte'  max-width='400')
    v-card.pa-3
      .flex-1
        v-card-title.pa-3.pl-4
          span.font-weight-700(:class="{'font-size-17' : isMovil}") Nuevo reporte
        v-card-subtitle.pb-3.font-size-13 Los filtros asignados a este nuevo reporte serán los parametros de tipo
          span.font-weight-700 &nbsp; {{tiposReporte[indexReporte].name}}
      v-text-field.pa-4.pb-0( hide-details v-model='query.titulo' ref="tituloModal"  dense :label="`Titulo  `" )
      v-text-field.pa-4.pb-0( hide-details v-model='query.descripcion'  dense :label="`Descripcion del resultado `" )
      v-card-actions.mt-8
        v-spacer
        v-btn.mr-1(color='ligth' small @click='closeModalGuardarReporte')
          |   cancelar
        v-btn(color='primary' small @click='fetchGuardarReporte()')
          |   Generar reporte
  v-card.mx-auto.elevation-1
    .d-flex(:class="{'fd-column' : isMovil}")
      .flex-1
        v-card-title.pa-3.pl-4
          span.font-weight-700(:class="{'font-size-17' : isMovil}")   Generador de reportes
        v-card-subtitle.pb-3.font-size-13   Crea, guarda y exporta tus reportes
    v-divider
    v-tabs.elevation-1.position-sticky(
      fixed-tabs=''
      v-if="isMovil"
    )
      v-tab(@click="tabActive = 1")
        small Listado Reportes
      v-tab(@click="tabActive = 2")
        small Parametros
    v-sheet.pa-3
      v-row
        v-col.b-right( cols='12' sm='3' v-if="!isMovil || isMovil && tabActive === 1")
          v-select.mb-3(
            :items='tiposListados'
            hide-details
            label='Tipo Listado'
            dense=''
            @change="definirNuevoReporte(), fetchObtenerListadoReportes(null)"
            v-model="indexTipoListadoReportes"
            solo=''
            item-value="id"
            item-text="name"
          )
          v-btn.mb-3(   block color='success' @click="definirNuevoReporte()" , :disabled="indexTipoListadoReportes === 1")
            v-icon.mr-2 add_circle
            |  reporte en blanco
          v-card.overflow-y-auto.elevation-0.px-1(max-height="calc(100vh - 251px)")
            v-card.pa-0.my-2.elevation-1(
              nav=''
              :dark="idReporteSeleccionado === item.id"
              dense='',
              :color="idReporteSeleccionado === item.id ? 'primary' : ''"
              v-for='(item, i) in listado'
              :key='i'
              @dblclick="goToPrevisualizarReporte(item.id, item.esReporteDefinido)"
            )
              v-list-item( @click="editarReporte(item, item.id)" )
                v-list-item-content
                  v-list-item-title.font-size-13
                    span.font-weight-700 {{item.titulo}}
                  v-list-item-subtitle.font-size-11 {{item.descripcion ? item.descripcion : 'No cuenta con subtitulo'}}
                  .d-flex.ai-center.mt-1
                    v-chip.mr-1(
                      x-small
                      :color="idReporteSeleccionado === item.id ? 'white primary--text' : 'primary'"
                    )
                      v-icon(left='', size="8")
                        | circle
                      span.font-weight-700.font-size-11 {{item.tipo}}
                    v-spacer
                    small.font-size-10.text-muted fue creado  {{item.fechaRegistro | now}}
                v-list-item-action.ma-0
                  v-menu(offset-y='')
                    template(v-slot:activator='{ on, attrs }')
                      v-btn(icon  v-bind='attrs' v-on='on' )
                        v-icon more_vert
                    v-list(dense)
                      v-list-item(@click="goToPrevisualizarReporte(item.id, item.esReporteDefinido)")
                        v-list-item-title Visualizar resultados
                      v-list-item(@click="openDialogExportar(item.id)")
                        v-list-item-title Exportar resultados
                      v-list-item(@click="openDialogEliminar(item)" v-if="!item.esReporteDefinido")
                        v-list-item-title.primary--text Eliminar permanentemente
        v-col.pa-0( cols='12' sm="9" v-if="!isMovil || isMovil && tabActive === 2")
          .d-flex.ai-center.flex-1.pa-4
            v-card.pa-2(
              :class="{'mr-4' : index < tiposReporte.length - 1}"
              :name="index"
              :id="tiposReporte.length - 1"
              :color="r.id === indexReporte ? 'primary white--text' : ''"
              @click="seleccionarTipoReporte(r.id)"
              :width="isMovil ? '' : 200"
              height="70"
              hover,
              v-for="(r, index) in tiposReporte"
              :key="index"
              :disabled="indexTipoListadoReportes === 1"
            )
              .d-flex.ai-center
                v-icon(left='' size="40" :color="r.id === indexReporte ? 'white' : 'background'")
                  | {{r.icon}}
                .flex-1.d-flex.fd-column
                  span.font-weight-700.font-size-20(:class="{'font-size-17' : isMovil}") {{r.name}}
                  small.font-size-11(:class="{'white--text' : r.id === indexReporte}") {{r.description}}
          .d-flex.fd-column(v-if="idReporteSeleccionado !== ''")
            v-text-field.pa-4.pb-0( hide-details v-model='query.titulo' ref="tituloCreado"  dense :label="`Titulo  `" :disabled="indexTipoListadoReportes === 1" )
            v-text-field.pa-4.pb-0( hide-details v-model='query.descripcion'  dense :label="`Descripcion del resultado`"  :disabled="indexTipoListadoReportes === 1")
          v-card-title
            span.font-weight-700(:class="{'font-size-17' : isMovil}") Asignación de parametros
          v-card.elevation-0.pa-3.overflow-y-auto.pt-0(:height="idReporteSeleccionado !== '' ? 'calc(100vh - 455px)' : 'calc(100vh - 364px)'")
            template(v-if="indexReporte === 0")
              v-text-field.pb-3(  @keyup.enter="fetch()" v-model='query.numero' :label="`Numero de ticket`"  persistent-hint  hint="Si usas este filtro, los demas parametros no se tomarán en cuenta" type="number")
              .d-flex(:class="{'fd-column' : isMovil}")
                .flex-1
                  .d-flex.py-2.fd-column
                    strong.font-size-12 Tipo
                    v-radio-group.pt-1.mt-1(v-model='query.tipo' hide-details @change="reRenderEstados()" )
                      //- v-radio.flex-1(value='contrato')
                      //-   template(v-slot:label='')
                      //-     strong(:class="{'primary--text' : query.tipo === 'contrato'}") Contrato
                      v-radio.flex-1(value='incidencia con equipo')
                        template(v-slot:label='')
                          strong(:class="{'primary--text' : query.tipo === 'incidencia con equipo'}")  Incidencia con equipo - contrato
                      v-radio.flex-1(value='solicitud de insumo')
                        template(v-slot:label='')
                          strong(:class="{'primary--text' : query.tipo === 'solicitud de insumo'}")  Solicitud de insumo - contrato
                      v-radio.flex-1(value='garantia')
                        template(v-slot:label='')
                          strong(:class="{'primary--text' : query.tipo === 'garantia'}")  Garantia
                      v-radio.flex-1(value='-1')
                        template(v-slot:label='')
                          strong(:class="{'primary--text' : query.tipo === '-1'}")  Todos
                .flex-1
                  .d-flex.py-2.fd-column
                    strong.font-size-12 Mostrar
                    v-radio-group.pt-1.mt-1(v-model='query.abierto' hide-details )
                      v-radio.flex-1(value='1')
                        template(v-slot:label='')
                          strong(:class="{'primary--text' : query.abierto === '1'}")  Abiertos
                      v-radio.flex-1(value='0')
                        template(v-slot:label='')
                          strong(:class="{'primary--text' : query.abierto === '0'}")  Cerrados
                      v-radio.flex-1(value='-1')
                        template(v-slot:label='')
                          strong(:class="{'primary--text' : query.abierto === '-1'}")  Todos
                .flex-1
                  .d-flex.py-2.fd-column
                    strong.font-size-12 Area
                    v-radio-group.pt-1.mt-1(v-model='query.area' hide-details )
                      v-radio.flex-1(value='campo')
                        template(v-slot:label='')
                          strong(:class="{'primary--text' : query.area === 'campo'}")  Campo
                      v-radio.flex-1(value='taller')
                        template(v-slot:label='')
                          strong(:class="{'primary--text' : query.area === 'taller'}")  Taller
                      v-radio.flex-1(value='sin asignacion')
                        template(v-slot:label='')
                          strong(:class="{'primary--text' : query.area === 'sin asignacion'}") Sin asignacion
                      v-radio.flex-1(value='-1')
                        template(v-slot:label='')
                          strong(:class="{'primary--text' : query.area === '-1'}") Todos
              .d-flex.py-2.fd-column(v-if="showFiltroEstados && query.tipo !== '-1'")
                strong.font-size-12 Estados
                estados-ticket.pt-1(:tipo="query.tipo",  show-clear  :codigo="query.estado"  @selected="obtenerEstado" )

              .d-flex.py-2.fd-column
                strong.font-size-12 Rango de fechas
                .d-flex(:class="{'fd-column' : isMovil}")
                  .flex-1.mr-2
                    v-text-field( hide-details @keyup.enter="fetch()" v-model='query.desde' label='Desde '  type="date")
                  .flex-1(:class="{'ml-2' : !isMovil}")
                    v-text-field( hide-details @keyup.enter="fetch()" v-model='query.hasta' label='Hasta '    type="date")
              .d-flex.py-2.fd-column
                strong.font-size-12 Especifico
                .d-flex(:class="{'fd-column' : isMovil}")
                  .flex-1.mr-2
                    v-text-field( hide-details @keyup.enter="fetch()" v-model='query.codigoCliente' label='Codigo de cliente - interno/sap' type="text")
                  .flex-1(:class="{'ml-2' : !isMovil}")
                    v-text-field( hide-details @keyup.enter="fetch()" v-model='query.serie' label='Serie' type="text" )
                  .flex-1(:class="{'ml-2' : !isMovil}")
                    v-text-field( hide-details @keyup.enter="fetch()" v-model='query.modelo' label='Modelo' type="text")
              .d-flex(v-if="query.tipo === 'garantia'", :class="{'fd-column' : isMovil}")
                .flex-1
                  .d-flex.py-2.fd-column
                    strong.font-size-12 Zona de asignacion
                    v-radio-group.pt-1.mt-1(v-model='query.zona' hide-details)
                      v-radio.flex-1(value='lima' )
                        template(v-slot:label='')
                          strong(:class="{'primary--text' : query.zona === 'lima'}")  Lima
                      v-radio.flex-1(value='arequipa')
                        template(v-slot:label='')
                          strong(:class="{'primary--text' : query.zona === 'arequipa'}")  Arequipa
                      v-radio.flex-1(value='sin asignacion')
                        template(v-slot:label='')
                          strong(:class="{'primary--text' : query.zona === 'sin asignacion'}")  Sin asignacion
                      v-radio.flex-1(value='-1')
                        template(v-slot:label='')
                          strong(:class="{'primary--text' : query.zona === '-1'}")  Todos
                .flex-1
                  .d-flex.py-2.fd-column
                    strong.font-size-12  ¿Ingresaron a taller?
                    v-radio-group.pt-1.mt-1(v-model='query.ingresoATaller' hide-details)
                      v-radio.flex-1(value='1' )
                        template(v-slot:label='')
                          strong(:class="{'primary--text' : query.ingresoATaller === '1'}")  Si
                      v-radio.flex-1(value='0')
                        template(v-slot:label='')
                          strong(:class="{'primary--text' : query.ingresoATaller === '0'}")  No
                      v-radio.flex-1(value='-1')
                        template(v-slot:label='')
                          strong(:class="{'primary--text' : query.ingresoATaller === '-1'}")  Todos

            template(v-if="indexReporte === 1")
              v-row.pt-1(dense, v-if="indexTipoListadoReportes === 0")
                v-col(cols='12' sm='4')
                  v-select(
                    hide-details
                    :items='columnasTicket'
                    return-object
                    item-value="valor"
                    item-text="nombre"
                    v-model="reporteAvanzado.campo"
                    :loading="isLoadingColumsTickets"
                    @change="validarDataType"
                    label='Seleccionar campo'
                    dense=''
                    solo=''
                  )
                v-col(cols='12' sm='2')
                  v-select(
                    hide-details
                    :items='itemsCondiciones'
                    return-object
                    item-value="valor"
                    item-text="name"
                    v-model="reporteAvanzado.criterio"
                    label='Criterios'
                    dense=''
                    solo=''
                  )
                v-col(cols='12' sm='4')
                  v-text-field( hide-details  v-model="reporteAvanzado.valor" :label="`Valor`" dense  :type="valorType" solo)
                  small.font-size-11(v-if="Object.keys(reporteAvanzado.campo).length") Valor aceptado: &nbsp;
                    strong {{reporteAvanzado.campo.descripcionType}}
                v-col(cols='12' sm='2')
                  v-btn( block   color='primary', @click="agregarQueryAvanzado()")
                    | Agregar
              v-data-table.elevation-0.mt-8(
                :headers='headersFiltrosAvanzados'
                :items='queryAvanzados'
                dense
                :disable-pagination="true"
                hide-default-footer
              )
                //- :sort-desc='[false, true]'
                //- :sort-by="['campo']"
                template(v-slot:item.columna="{ item }")
                  span {{item.columna.nombre}}
                template(v-slot:item.actions="{ item, index }")
                  .d-flex.ai-center(:class="{'ma-1' : !isMovil}")
                    v-btn.mr-2(fab x-small  @click="editarRowFiltrosAvanzados(index)" :disabled="indexTipoListadoReportes === 1")
                      v-icon edit
                    v-btn(fab x-small color="primary" @click="eliminarRowFiltrosAvanzados(index)"  :disabled="indexTipoListadoReportes === 1")
                      v-icon delete
                template(v-slot:item.condicion="{ item }")
                  strong {{item.condicion.name}}
          .d-flex.pa-4.border-top
            .flex-1
            .flex-1.jc-end.d-flex
              v-btn.mr-3(small='' color='primary' @click="goToPrevisualizarReporte()")
                span(v-if="idReporteSeleccionado !== ''") Previsualizar
                span(v-else) Ver datos borrador
              v-btn(small='' color='success' @click="verificarSiEsReporteNuevo()" :disabled="indexTipoListadoReportes === 1")
                span(v-if="idReporteSeleccionado !== ''") Guardar cambios
                span(v-else) Guardar datos
</template>
<script>
  import moment                                 from 'moment'
  import { apiDelete, apiGet, apiPost, notify } from '../util/general'
  import estadosTicket                          from '@/components/c_estados_tickets'
  import parametrosExportacion                  from '@/components/c_reporte_parametros_exportacion'
  export default {
    props : {
    },
    components: {
      'estados-ticket'        : estadosTicket,
      'parametros-exportacion': parametrosExportacion
    },
    data () {
      return {
        tabActive              : 1,
        reporteAEliminar       : {},
        headersFiltrosAvanzados: [
          {text    : 'Columna', value   : 'columna'},
          {text: 'Criterio', value: 'condicion'},
          {text: 'Valor', value: 'value'},
          { text: 'Acciones', value: 'actions', sortable: false, width: '100' }
        ],
        idReporteSeleccionado: '',
        indexTipoListadoReportes: 0,
        showFiltroEstados       : true,
        listado                 : [],
        tiposReporte            : [
          {
            name       :  'Basico',
            description:  'Informes de evaluacion',
            icon       :  'addchart',
            id         : 0
          },
          {
            name       :  'Avanzado',
            description:  'Indicadores (Analisis)',
            icon       :  'donut_small',
            id         : 1
          }
        ],
        tiposListados : [
          {
            name       :  'Mis reportes guardados',
            description:  'Usa para informes de evaluacion',
            icon       :  'addchart',
            id         : 0
          },
          {
            name       :  'Reportes predefinidos',
            description:  'Usa para indicadores (Analisis)',
            icon       :  'donut_small',
            id         : 1
          }
        ],
        itemsCondiciones : [
          {
            name : 'Es igual a',
            valor : '='
          },
          {
            name : 'Es diferente a',
            valor : '<>'
          },
          {
            name : 'Mayor que',
            valor : '>'
          },
          {
            name : 'Mayor igual que',
            valor : '>='
          },
          {
            name : 'Menor que',
            valor : '<'
          },
          {
            name : 'Menor igual que',
            valor : '<='
          }
        ],
        reporteAvanzado : {
          campo   : {},
          criterio: {},
          valor   : ''
        },
        query: {
          titulo           : '',
          descripcion      : '',
          tipo             : '-1',
          desde            : '',
          hasta            : '',
          numero           : '',
          estado           : 0,
          codigoCliente    : '',
          serie            : '',
          modelo           : '',
          zona             : '-1',
          area             : '-1',
          abierto          : '-1',
          ingresoATaller   : '-1'
        },
        indexReporte         : 0,
        isModalEliminar      : false,
        queryAvanzados       : [],
        columnasTicket       : [],
        valorType            : 'text',
        isModalExportar      : false,
        idReporteExportar    : 0,
        isModalGuardarReporte: false
      }
    },
    created () {
      var vm = this
      vm.fetchObtenerListadoReportes()
    },
    computed : {
      isMovil () {
        var vm = this
        return vm.$vuetify.breakpoint.smAndDown
      }
    },
    filters : {
      now: function (value) {
        if (!value) return ''
        return moment(value).fromNow()
      }
    },
    methods: {
      openDialogExportar (idReporte) {
        var vm = this
        vm.idReporteExportar = idReporte
        vm.isModalExportar = true
      },
      closeModalGuardarReporte (isBorrarTitulo = true) {
        var vm = this
        if (isBorrarTitulo) {
          vm.query.titulo = ''
          vm.query.descripcion = ''
        }
        vm.isModalGuardarReporte = false
      },
      verificarSiEsReporteNuevo () {
        var vm = this
        if (vm.idReporteSeleccionado !== '') vm.fetchGuardarReporte()
        else vm.openModalGuardarReporte()
      },
      openModalGuardarReporte  () {
        var vm = this
        vm.isModalGuardarReporte = true
      },
      closeDialogExportar () {
        var vm = this
        vm.isModalExportar = false
      },
      openDialogEliminar (reporte) {
        var vm = this
        vm.reporteAEliminar = reporte
        vm.isModalEliminar = true
      },
      closeDialogEliminar () {
        var vm = this
        vm.reporteAEliminar = {}
        vm.isModalEliminar = false
      },
      obtenerEstado (estado) {
        var vm = this
        vm.query.estado            = estado.codigo
      },
      goToPrevisualizarReporte (idReporte = '', esReporteDefinido) {
        var vm     = this
        var url    = null
        var query  = {}
        var params = {}
        if (idReporte !== '') {
          query.id      = idReporte
          if (esReporteDefinido) query.default = 1
          params.tipo   = 'save'
          url           = vm.$router.resolve({ name  : 'reportes_view', params, query })
          window.open(url.href, '_blank')
        } else {
          if (vm.idReporteSeleccionado !== '') {
            query.id      = vm.idReporteSeleccionado
            var definido  = vm.listado.find(e => e.id === vm.idReporteSeleccionado)
            if (definido.esReporteDefinido) query.default = definido.esReporteDefinido
            params.tipo   = 'save'
            url           = vm.$router.resolve({ name  : 'reportes_view', params, query })
            window.open(url.href, '_blank')
          } else {
            params.tipo         = 'draft'
            var reporteDraft = vm.tiposReporte[vm.indexReporte]
            var filtrosDraft = null
            if (reporteDraft.name === 'Basico') {
              filtrosDraft = vm.query
            } else if (reporteDraft.name === 'Avanzado') {
              filtrosDraft = vm.queryAvanzados
            } else {
              notify(vm, 'error', 'Error', 'El tipo de reporte es invalido')
              return
            }

            vm.handlerFormatearFiltrosDraft(reporteDraft, filtrosDraft, (err, filtrosQuery) => {
              if (err) {
                notify(vm, 'error', 'Error', err)
                return
              }

              query = filtrosQuery
              url   = vm.$router.resolve({ name  : 'reportes_view', params, query })
              window.open(url.href, '_blank')
            })
          }
        }
      },
      handlerFormatearFiltrosDraft (reporte, filtros, callback) {
        if (reporte.name === 'Basico') {
          filtros.tipoReporte = reporte.name.toLowerCase()
          callback(null, filtros)
        } else if (reporte.name === 'Avanzado') {
          var jsonFiltros = {
            tipoReporte : reporte.name.toLowerCase()
          }
          filtros.forEach((e, i) => {
            jsonFiltros[e.columna.valor] = e.condicion.valor + ',' + e.value
          })
          callback(null, jsonFiltros)
        } else {
          callback('El tipo de reporte es invalido')
        }
      },
      definirNuevoReporte () {
        var vm = this
        vm.indexReporte = 0
        vm.idReporteSeleccionado = ''
        vm.queryAvanzados = []
        vm.query.titulo             = ''
        vm.query.descripcion        = ''
        vm.query.tipo               = '-1'
        vm.query.desde              = ''
        vm.query.hasta              = ''
        vm.query.numero             = ''
        vm.query.estado             = 0
        vm.query.codigoCliente      = ''
        vm.query.serie              = ''
        vm.query.modelo             = ''
        vm.query.zona               = '-1'
        vm.query.area               = '-1'
        vm.query.abierto            = '-1'
        vm.query.ingresoATaller     = '-1'
        vm.reporteAvanzado.campo    = {}
        vm.reporteAvanzado.criterio = {}
        vm.reporteAvanzado.valor = ''
        if (vm.isMovil) {
          vm.$nextTick(() => {
            vm.tabActive = 2
          })
        }
      },
      editarReporte (reporte, idReporte) {
        var vm = this
        if (vm.isMovil) vm.tabActive = 2
        vm.definirNuevoReporte()
        vm.idReporteSeleccionado = idReporte
        if (reporte.tipo === 'basico') {
          vm.indexReporte = 0
          vm.query        = JSON.parse(reporte.filtros)
        } else if (reporte.tipo === 'avanzado') {
          if (vm.indexTipoListadoReportes !== 1) vm.fetchColumnasDeLaTablaTicket()
          vm.indexReporte      = 1
          vm.query.titulo      = reporte.titulo
          vm.query.descripcion = reporte.descripcion
          vm.queryAvanzados    = JSON.parse(reporte.filtros)
        } else {
          notify(vm, 'error', 'Error', 'El tipo de reporte no esta definido')
        }
      },
      validarDataType () {
        var vm = this
        if (Object.keys(vm.reporteAvanzado.campo).length) {
          if (vm.reporteAvanzado.campo.type === 'nvarchar' || vm.reporteAvanzado.campo.type === 'varchar' || vm.reporteAvanzado.campo.type === 'ntext') vm.valorType = 'text'
          else if (vm.reporteAvanzado.campo.type === 'int' || vm.reporteAvanzado.campo.type === 'decimal') vm.valorType = 'number'
          else if (vm.reporteAvanzado.campo.type === 'datetime') vm.valorType = 'date'
        }
      },
      eliminarRowFiltrosAvanzados (index) {
        var vm = this
        vm.queryAvanzados.splice(index, 1)
      },
      editarRowFiltrosAvanzados (index) {
        var vm                          = this
        vm.reporteAvanzado.campo      = vm.queryAvanzados[index].columna
        vm.reporteAvanzado.criterio   = vm.queryAvanzados[index].condicion
        vm.reporteAvanzado.valor      = vm.queryAvanzados[index].value
        vm.eliminarRowFiltrosAvanzados(index)
        vm.validarDataType()
      },
      seleccionarTipoReporte (id) {
        var vm = this
        vm.indexReporte = id
        if (vm.indexReporte === 1) {
          vm.fetchColumnasDeLaTablaTicket()
        }
      },
      agregarQueryAvanzado () {
        var vm = this
        if (!vm.reporteAvanzado.campo) {
          notify(vm, 'error', 'Error', 'Seleccione un campo para agregar el filtro')
          return
        }
        if (!vm.reporteAvanzado.criterio) {
          notify(vm, 'error', 'Error', 'Seleccione un criterio para agregar el filtro')
          return
        }
        if (!vm.reporteAvanzado.valor) {
          notify(vm, 'error', 'Error', 'Ingrese un valor para el criterio  y continuar agregando el filtro')
          return
        }

        var obj = {
          columna  : vm.reporteAvanzado.campo,
          condicion: vm.reporteAvanzado.criterio,
          value    : vm.reporteAvanzado.valor
        }

        vm.queryAvanzados.push(obj)
      },
      reRenderEstados () {
        var vm = this
        vm.query.estado = 0
        vm.showFiltroEstados = false
        vm.$nextTick(() => {
          vm.showFiltroEstados = true
        })
      },
      fetchRealizarConsulta () {
        var vm = this
        vm.fetch()
      },
      fetchEliminarReporte () {
        var vm = this
        var url = 'reporte/eliminar'
        vm.$store.dispatch('transaccion', { isProceso : true, message : 'Eliminando  el reporte' })
        var obj = {
          id : vm.reporteAEliminar.id
        }

        apiDelete(vm, url, obj, function (data) {
          vm.closeDialogEliminar()
          vm.fetchObtenerListadoReportes()
          vm.definirNuevoReporte()
        }, function (err) {
          notify(vm, 'error', 'Error', err.message)
        }, function () {
          vm.$store.dispatch('transaccion', {isProceso : false})
        })
      },
      fetchObtenerListadoReportes (callback) {
        var vm = this
        var url = 'reporte/obtener'
        vm.$store.dispatch('transaccion', { isProceso : true, message : 'Obteniendo listado de reportes' })
        var obj = {
          tipoListado : vm.tiposListados[vm.indexTipoListadoReportes].id
        }

        apiGet(vm, url, obj, function (data) {
          vm.listado = data.lista
          if (vm.indexTipoListadoReportes === 1 && vm.listado.length) {
            vm.editarReporte(vm.listado[0], vm.listado[0].id)
          }
          callback && callback()
        }, function (err) {
          notify(vm, 'error', 'Error', err.message)
          callback && callback()
        }, function () {
          vm.$store.dispatch('transaccion', {isProceso : false})
        })
      },
      fetchGuardarReporte () {
        var vm = this
        if (!vm.query.titulo) {
          notify(vm, 'error', 'Error', 'Ingrese un titulo para el reporte')
          if (vm.idReporteSeleccionado !== '') {
            vm.$refs.tituloCreado.$refs.input.focus()
          } else {
            vm.$refs.tituloModal.$refs.input.focus()
          }
          return
        }

        var url = 'reporte/guardar'
        vm.$store.dispatch('transaccion', { isProceso : true, message : 'Guardando cambios de reporte' })
        var obj = {
          filtrosBasicos  : vm.query,
          filtrosAvanzados: vm.queryAvanzados,
          tipo            : vm.tiposReporte[vm.indexReporte].name.toLowerCase(),
          titulo          : vm.query.titulo,
          descripcion     : vm.query.descripcion,
          id              : vm.idReporteSeleccionado || ''
        }

        apiPost(vm, url, obj, function (data) {
          notify(vm, 'success', 'Exito', 'El reporte se guardó correctamente')
          vm.closeModalGuardarReporte(vm.idReporteSeleccionado === '')
          vm.fetchObtenerListadoReportes(() => {
            if (vm.idReporteSeleccionado === '') {
              var item = vm.listado.find(e => e.id === data.id)
              vm.editarReporte(item, data.id)
            }
          })
        }, function (err) {
          notify(vm, 'error', 'Error', err.message)
        }, function () {
          vm.$store.dispatch('transaccion', {isProceso : false})
        })
      },
      fetchColumnasDeLaTablaTicket () {
        var vm = this
        var url = '/ticket/get/columns'
        vm.isLoadingColumsTickets = true
        vm.columnasTicket = []
        var obj = {
          formateado : true
        }
        apiGet(vm, url, obj, function (data) {
          for (var i = 0; i < data.lista.length; i++) {
            vm.columnasTicket.push(data.lista[i])
          }
        }, function (err) {
          notify(vm, 'error', 'Error', err.message)
        }, function () {
          vm.isLoadingColumsTickets = false
        })
      }
    }
  }
</script>
<style  lang="stylus" scoped>
.b-right
  border-right: 1.5px solid #ffffff1f;
.b-left
  border-left: 1.5px solid #ffffff1f;
.border-top
  border-top: 1.5px solid #ffffff1f;
.position-sticky
  position: sticky;
  top     : 40px;
  z-index : 5;
</style>



// WEBPACK FOOTER //
// View_reportes.vue?6656821e